import { ranking, hotWords, todayMeta } from '@/mocks/gossipData';
import { fmtWan } from './format';

export default function HeatRanking() {
  const maxHeat = Math.max(...ranking.map((r) => r.heat));

  return (
    <section id="heat" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
              <i className="ri-fire-line" />
              热度榜
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              正在被全网围观的瓜
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              榜单与热度在吃瓜语境下最直观——围观涨跌，一眼看懂今天风向。
            </p>
          </div>
          <span className="text-xs text-foreground-500">每 5 分钟刷新围观指数</span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {/* 榜单 */}
          <div className="overflow-hidden rounded-2xl border border-background-200 bg-white lg:col-span-2">
            {ranking.map((r, i) => (
              <div
                key={r.rank}
                className={`group flex items-center gap-4 px-4 py-4 md:px-6 ${i !== ranking.length - 1 ? 'border-b border-background-100' : ''}`}
              >
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-heading text-sm font-bold ${
                    r.rank <= 3 ? 'bg-accent-500 text-background-50' : 'bg-background-100 text-foreground-400'
                  }`}
                >
                  {r.rank}
                </span>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700">
                  <i className={r.icon} />
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <a href="#fresh" className="font-semibold text-foreground-950 hover:text-primary-700 cursor-pointer">
                      {r.title}
                    </a>
                  </div>
                  <div className="mt-1.5 h-1 w-full overflow-hidden rounded-full bg-background-100">
                    <div
                      className="rise-bar h-full rounded-full bg-gradient-to-r from-secondary-400 to-accent-500"
                      style={{ width: `${(r.heat / maxHeat) * 90}%` }}
                    />
                  </div>
                </div>
                <div className="hidden shrink-0 flex-col items-end gap-0.5 sm:flex">
                  <span className="text-sm font-bold text-foreground-950">{fmtWan(r.heat)}</span>
                  <span className="flex items-center gap-1 text-xs font-semibold">
                    <i
                      className={
                        r.up
                          ? 'ri-arrow-up-line text-primary-600'
                          : 'ri-arrow-down-line text-foreground-400'
                      }
                    />
                    <span className={r.up ? 'text-primary-700' : 'text-foreground-500'}>{r.delta}</span>
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* 右侧：热词 + 今日概况 */}
          <div className="flex flex-col gap-5">
            <div className="rounded-2xl border border-background-200 bg-background-100 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-price-tag-3-line text-accent-600" />
                今日热词
              </h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {hotWords.map((w) => (
                  <span
                    key={w.word}
                    className="rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-700 cursor-pointer hover:border-accent-300 hover:bg-accent-100"
                    style={{ fontSize: `${10 + Math.round((w.strength / 96) * 4)}px` }}
                  >
                    {w.word}
                  </span>
                ))}
              </div>
            </div>

            <div className="rounded-2xl bg-foreground-950 p-5 text-background-50">
              <div className="flex items-center justify-between">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold">
                  <i className="ri-pulse-line text-accent-400" />
                  今日吃瓜概况
                </h3>
                <i className="ri-arrow-right-line text-foreground-400" />
              </div>
              <div className="mt-5 grid grid-cols-2 gap-4">
                <div className="rounded-xl bg-white/5 p-3">
                  <div className="font-heading text-2xl font-bold text-accent-400">{todayMeta.count}</div>
                  <div className="mt-1 text-xs text-foreground-300">今日已更新</div>
                </div>
                <div className="rounded-xl bg-white/5 p-3">
                  <div className="font-heading text-2xl font-bold text-accent-400">4.2w</div>
                  <div className="mt-1 text-xs text-foreground-300">同时在线吃瓜</div>
                </div>
              </div>
              <div className="mt-4 flex items-center gap-2 text-xs text-foreground-300">
                <i className="ri-time-line" />
                围观峰值约在 {todayMeta.peak}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}